import React from 'react';

export function QuoteIcon() {
  return (
    <svg width="38" height="43" viewBox="0 0 38 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.12">
        <path
          d="M0 18.5492C0 13.0158 4.4435 8.48843 10.0608 8.48843H10.7315C12.1568 8.48843 13.4144 9.74602 13.4144 11.1713C13.4144 12.6804 12.1568 13.8542 10.7315 13.8542H10.0608C7.46173 13.8542 5.36574 16.034 5.36574 18.5492V19.2199H10.7315C13.6659 19.2199 16.0972 21.6513 16.0972 24.5856V29.9514C16.0972 32.9696 13.6659 35.3171 10.7315 35.3171H5.36574C2.34751 35.3171 0 32.9696 0 29.9514V27.2685V24.5856V18.5492ZM21.463 18.5492C21.463 13.0158 25.9065 8.48843 31.5237 8.48843H32.1944C33.6197 8.48843 34.8773 9.74602 34.8773 11.1713C34.8773 12.6804 33.6197 13.8542 32.1944 13.8542H31.5237C28.9247 13.8542 26.8287 16.034 26.8287 18.5492V19.2199H32.1944C35.1288 19.2199 37.5602 21.6513 37.5602 24.5856V29.9514C37.5602 32.9696 35.1288 35.3171 32.1944 35.3171H26.8287C23.8105 35.3171 21.463 32.9696 21.463 29.9514V27.2685V24.5856V18.5492Z"
          fill="#003E54"
        />
      </g>
    </svg>
  );
}
